export const push = (arg: Record<string, string>): void => {
  window.dataLayer && window.dataLayer.push(arg);
};
